import { useNavigate } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import { usePharmacy } from '@/context/PharmacyContext';
import { useAuth } from '@/hooks/useAuth';

export default function AdminDashboardPage() {
  const { settings } = usePharmacy();
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <div className="p-6 md:p-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-foreground-950">Dashboard</h1>
          <p className="text-sm text-foreground-600 mt-1">
            Welcome back, {user?.user_metadata?.display_name || user?.email || 'Admin'}
          </p>
        </div>

        {/* Quick stats */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {[
            { label: 'Pharmacy Name', value: settings?.pharmacy_name || 'N/A', icon: 'ri-store-2-line', color: 'bg-primary-50 text-primary-600' },
            { label: 'Phone', value: settings?.phone || 'N/A', icon: 'ri-phone-line', color: 'bg-accent-50 text-accent-600' },
            { label: 'Address', value: settings ? `${settings.city}, ${settings.province}` : 'N/A', icon: 'ri-map-pin-line', color: 'bg-secondary-50 text-secondary-600' },
          ].map((stat) => (
            <div key={stat.label} className="bg-background-50 border border-background-200 rounded-xl p-5">
              <div className={`w-10 h-10 ${stat.color} rounded-lg flex items-center justify-center mb-3`}>
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-1">{stat.label}</p>
              <p className="text-sm font-bold text-foreground-950">{stat.value}</p>
            </div>
          ))}
        </div>

        {/* Quick actions */}
        <div className="mb-8">
          <h2 className="text-lg font-bold text-foreground-950 mb-4">Quick Actions</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <button
              onClick={() => navigate('/admin/pharmacy-settings')}
              className="bg-background-50 border border-background-200 rounded-xl p-5 text-left hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 bg-primary-50 text-primary-600 rounded-lg flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors">
                <i className="ri-settings-3-line text-lg"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-950 mb-1">Pharmacy Settings</h3>
              <p className="text-xs text-foreground-500">Manage address, phone, hours, doctor schedules</p>
            </button>

            <button
              onClick={() => navigate('/admin/blog')}
              className="bg-background-50 border border-background-200 rounded-xl p-5 text-left hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 bg-accent-50 text-accent-600 rounded-lg flex items-center justify-center mb-3 group-hover:bg-accent-100 transition-colors">
                <i className="ri-article-line text-lg"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-950 mb-1">Blog Management</h3>
              <p className="text-xs text-foreground-500">Create and manage blog posts</p>
            </button>
          </div>
        </div>

        {/* System status */}
        <div className="bg-background-50 border border-background-200 rounded-xl p-5">
          <h2 className="text-base font-bold text-foreground-950 mb-4">System Status</h2>
          <div className="space-y-3">
            <div className="flex items-center justify-between py-2 border-b border-background-100">
              <span className="text-sm text-foreground-600">Pharmacy Data Source</span>
              <span className="flex items-center gap-1.5 text-xs font-medium text-green-600">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                Supabase
              </span>
            </div>
            <div className="flex items-center justify-between py-2 border-b border-background-100">
              <span className="text-sm text-foreground-600">Last Settings Update</span>
              <span className="text-xs text-foreground-500">
                {settings?.id ? 'Connected' : 'Using defaults'}
              </span>
            </div>
            <div className="flex items-center justify-between py-2">
              <span className="text-sm text-foreground-600">Admin Auth</span>
              <span className="flex items-center gap-1.5 text-xs font-medium text-green-600">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                Active
              </span>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}